/**
 * Created by psivanappans on 10/17/2022
 * File: InstanceTitle
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Subtitle, Title } from '@panwds/react-ui'
import AppImage from '../../../../../common/components/appName/AppImage'
import { useMemo } from 'react'
import { getAppTitle } from '../../../../util/common'

const InstanceTitle = ({ appDef, license }) => {
  const appTitle = useMemo(() => {
    return getAppTitle(license, appDef)
  }, [appDef, license])

  const subTitle = useMemo(() => {
    return appDef?.sub_title
  }, [appDef?.sub_title])

  return (
    <div className="tw-p-3 tw-flex tw-gap-2 tw-items-center">
      <AppImage
        style={{ width: '36px', height: '48px' }}
        app_id={appDef?.app_id}
        alt={appTitle} />
      <div>
        <Title size="sm" level={2} >{appTitle}</Title>
        {subTitle && <Subtitle>{subTitle}</Subtitle>}
      </div>
    </div >
  )
}

InstanceTitle.propTypes = {}

export default InstanceTitle
